import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [ "container", "more", "item" ]

  connect() {
    this.initInfinite()
  }

  initInfinite() {
    // destroy existing instance if any
    if (this.infinite && typeof this.infinite.destroy === 'function') {
      try { this.infinite.destroy() } catch (e) { /* ignore */ }
    }

    this.infinite = new Waypoint.Infinite({
      element: this.containerTarget,
      items: "[data-target='infinite-page.item']",
      more: "a[data-target='infinite-page.more']",
      loadingClass: "loading",
    })
  }

  clear(event) {
    // Stop the infinite loader and remove any 'more' links so it won't keep fetching
    if (this.infinite && typeof this.infinite.destroy === 'function') {
      try { this.infinite.destroy() } catch (e) { /* ignore */ }
    }

    const moreLinks = this.element.querySelectorAll("a[data-target='infinite-page.more']")
    moreLinks.forEach(l => l.remove())
    this.containerTarget.classList.remove('loading')
    // Allow normal navigation (full page visit/refresh) to proceed
  }

  disconnect() {
    if (this.infinite && typeof this.infinite.destroy === 'function') {
      try { this.infinite.destroy() } catch (e) { /* ignore */ }
    }
  }

}
